import { SITE_NAME, FAVICON_URL, SITE_DEFAULT_LOCALE } from './config';

const SCHEMA_ATTR = 'data-readdy-seo-schema';

function append(jsonLd: object): void {
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.setAttribute(SCHEMA_ATTR, 'true');
  script.textContent = JSON.stringify(jsonLd);
  document.head.appendChild(script);
}

export function clearSchemas(): void {
  document
    .querySelectorAll(`script[${SCHEMA_ATTR}]`)
    .forEach((el) => el.remove());
}

export function applySchemas(schemas: object[]): void {
  schemas.forEach(append);
}

export function buildOrganizationSchema(origin: string): object {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: origin,
    logo: FAVICON_URL,
  };
}

export function buildWebSiteSchema(origin: string): object {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: origin,
    inLanguage: ['pt-BR', 'en', 'de'],
  };
}

export function buildWebPageSchema(
  title: string,
  url: string,
  description: string,
): object {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    url,
    description,
    inLanguage: SITE_DEFAULT_LOCALE,
  };
}

export function buildArticleSchema(
  article: {
    title: string;
    metaDescription: string;
    image: string;
    publishedAt: string;
    updatedAt: string;
    author: string;
    slug: string;
  },
  origin: string,
): object {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.metaDescription,
    image: article.image,
    datePublished: article.publishedAt,
    dateModified: article.updatedAt,
    author: {
      '@type': 'Organization',
      name: article.author,
    },
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      logo: {
        '@type': 'ImageObject',
        url: FAVICON_URL,
      },
    },
    mainEntityOfPage: `${origin}/article/${article.slug}`,
    inLanguage: SITE_DEFAULT_LOCALE,
  };
}

export function buildBreadcrumbList(
  items: { name: string; url: string }[],
): object {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}